import { Link, useLocation } from "react-router-dom";
import CONSTANTS from '../CONSTANTS';

export default function NavLink(props) {
    const location = useLocation();
    const ROUTES = CONSTANTS.ROUTES;

    const { isBgBlack, ...rest } = props;

    let path = location.pathname;

    if (path !== ROUTES.home.path) {
        path = path.replace(/\/$/, '');
    }

    var isActive = false;

    if (props.to === ROUTES.home.path) {
        isActive = path === props.to;
    } else {
        isActive = path.startsWith(props.to);
    }
    
    var className = isActive ? 'active' : '';

    className += isBgBlack ? ' black' : '';

    return (
        <li>
            <Link {...rest} className={className}>
                {props.children}
            </Link>
        </li>
    );
}